import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_ACCESS} from '../../constants';

export default {
  id: 'ROLE',
  title: 'Quel est mon rôle ?',
  description: '',
  categories: [CONTENT_CATEGORY_ACCESS],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'Pour connaitre votre rôle, rendez-vous dans l’onglet « Paramètres » puis « Utilisateurs ».'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_ROLE/FR_ROLE_1.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Plusieurs rôles utilisateurs sont disponibles avec OnceForAll.'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Voici la liste des différents rôles :'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: '- Manager de compte: C’est l’administrateur du compte. Il met à jour les documents, gère les relations entreprises et gère les utilisateurs liés à l’entreprise'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: '- Invitant : Il gère principalement les mises en relations de l’entreprise (clients/fournisseurs)'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: '- Consultant : Il peut simplement consulter les documents des fournisseurs. Il peut aussi consulter le dossier de son entreprise'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: '- Exploreur : Il peut consulter et inviter ses fournisseurs uniquement'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Et des permissions :'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: '- E-signature : permission permettant de signer électroniquement les documents'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: '- Gestion des opérations : permission permettant de gérer des opérations'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Chaque utilisateur d’un établissement peut consulter son rôle, ses permissions et ceux des autres.'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_ROLE/FR_ROLE_2.png`
  }]
};
